module.exports = __webpack_public_path__ + "static/media/Arrow_Right_To_White.dccb37d2.svg";